/**
 * API - POSTS
 * https://bitbucket.org/interlective/bridgealliance_react_frontend
 */

//Search Post
async function searchPosts(token,page,formdata) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/getposts?page=${page}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(formdata)
    });
  }

  async function searchOffering(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-offering?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }
  async function searchResource(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-resource?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

  //Sales Template
  async function searchSalesTemplate(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-salestemplate?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

  //IoTWG Materials
  async function searchIoTWGMaterial(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-iotwgmaterial?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

  //IoT Frameworks
  async function searchIoTFramework(token,slug,env) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-iotframework?slug=${slug}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({"env":env})
    });
  }

export default {
    searchPosts,
    searchOffering,
    searchResource,
    searchSalesTemplate,
    searchIoTWGMaterial,
    searchIoTFramework
}